module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTranscripts && _vm.displayedTranscripts.length === 0),
      expression: "loadingTranscripts && displayedTranscripts.length === 0"
    }],
    attrs: {
      "element-loading-text": "Loading voice notes transcripts..."
    }
  }, [_c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "infinite-list-wrapper",
    attrs: {
      "infinite-scroll-disabled": "disabled",
      "infinite-scroll-distance": "100"
    }
  }, [_c('el-row', {
    staticClass: "voice-grid",
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.displayedTranscripts), function(vn) {
    return _c('el-col', {
      key: vn.id,
      staticClass: "voice-col",
      attrs: {
        "xs": 24,
        "sm": 12,
        "md": 12,
        "lg": 12,
        "xl": 12
      }
    }, [_c('el-card', {
      staticClass: "voice-card",
      attrs: {
        "shadow": "hover",
        "body-style": {
          padding: '15px',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('el-row', {
      attrs: {
        "type": "flex",
        "justify": "space-between",
        "align": "middle"
      }
    }, [_c('el-rate', {
      attrs: {
        "disabled": ""
      },
      model: {
        value: (vn.score),
        callback: function($$v) {
          _vm.$set(vn, "score", $$v)
        },
        expression: "vn.score"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "header-badges"
    }, [(vn.approved) ? _c('el-tag', {
      attrs: {
        "type": "success",
        "effect": "dark",
        "size": "small"
      }
    }, [_c('i', {
      staticClass: "fa fa-podcast",
      staticStyle: {
        "margin-right": "4px"
      }
    }), _vm._v(" On Air\n                ")]) : _vm._e(), _vm._v(" "), (vn.flagged) ? _c('el-tag', {
      attrs: {
        "type": "danger",
        "effect": "plain",
        "size": "small"
      }
    }, [_c('i', {
      staticClass: "fa fa-flag",
      staticStyle: {
        "margin-right": "4px"
      }
    }), _vm._v(" Flagged\n                ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "voice-content"
    }, [_c('div', {
      staticClass: "note-name"
    }, [_c('i', {
      staticClass: "el-icon-user"
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(vn.sender))])]), _vm._v(" "), (vn.location) ? _c('div', {
      staticClass: "note-location"
    }, [_c('i', {
      staticClass: "el-icon-location"
    }), _vm._v(" " + _vm._s(vn.location) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "note-time"
    }, [_c('i', {
      staticClass: "el-icon-time"
    }), _vm._v(" " + _vm._s(_vm.displayDatetime(vn.timestamp)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "note-summary"
    }, [_vm._v(_vm._s(vn.transcript))]), _vm._v(" "), (vn.tags && vn.tags.length) ? _c('div', {
      staticClass: "note-tags"
    }, [_c('span', {
      staticClass: "tag-label"
    }, [_vm._v("Tags")]), _vm._v(" "), _vm._l((vn.tags.slice(0, 2)), function(tag) {
      return _c('el-tag', {
        key: tag,
        staticClass: "tag",
        attrs: {
          "size": "mini",
          "effect": "light"
        }
      }, [_c('i', {
        staticClass: "fa fa-tag"
      }), _vm._v(" " + _vm._s(tag) + "\n              ")])
    }), _vm._v(" "), (vn.tags.length > 2) ? _c('el-tag', {
      attrs: {
        "size": "mini",
        "type": "info",
        "effect": "plain"
      }
    }, [_vm._v("\n                +" + _vm._s(vn.tags.length - 2) + "\n              ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (vn.people && vn.people.length) ? _c('div', {
      staticClass: "note-tags"
    }, [_c('span', {
      staticClass: "tag-label"
    }, [_vm._v("People")]), _vm._v(" "), _vm._l((vn.people.slice(0, 2)), function(person) {
      return _c('el-tag', {
        key: person,
        staticClass: "tag",
        attrs: {
          "size": "mini",
          "type": "info",
          "effect": "plain"
        }
      }, [_c('i', {
        staticClass: "el-icon-user"
      }), _vm._v(" " + _vm._s(person) + "\n              ")])
    }), _vm._v(" "), (vn.people.length > 2) ? _c('el-tag', {
      attrs: {
        "size": "mini",
        "type": "info",
        "effect": "plain"
      }
    }, [_vm._v("\n                +" + _vm._s(vn.people.length - 2) + "\n              ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (vn.audioUrl) ? _c('audio', {
      staticClass: "voice-audio",
      attrs: {
        "src": vn.audioUrl,
        "controls": "",
        "preload": "meta"
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "voice-actions"
    }, [_c('el-button', {
      attrs: {
        "size": "small",
        "type": vn.approved ? 'success' : '',
        "plain": vn.approved
      },
      on: {
        "click": function($event) {
          return _vm.onApprove(vn)
        }
      }
    }, [_c('i', {
      class: vn.approved ? 'fa fa-podcast' : 'fa fa-check'
    }), _vm._v("\n              " + _vm._s(vn.approved ? 'On Air' : 'Approve') + "\n            ")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "small",
        "type": vn.flagged ? 'danger' : '',
        "plain": vn.flagged
      },
      on: {
        "click": function($event) {
          return _vm.onToggleFlag(vn)
        }
      }
    }, [_c('i', {
      class: vn.flagged ? 'fa fa-flag' : 'fa fa-flag-o'
    }), _vm._v("\n              " + _vm._s(vn.flagged ? 'Flagged' : 'Flag') + "\n            ")]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "margin-left": "auto"
      },
      attrs: {
        "size": "small",
        "type": "info",
        "plain": ""
      },
      on: {
        "click": function($event) {
          return _vm.onPreviewAudio(vn)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" Preview\n            ")])], 1)])], 1)
  }), 1), _vm._v(" "), (_vm.displayedTranscripts.length > 0) ? _c('div', {
    staticClass: "no-more"
  }, [_c('el-divider', [_c('i', {
    staticClass: "el-icon-finished"
  }), _vm._v(" All voice notes loaded ")]), _vm._v(" "), _c('p', {
    staticClass: "stats"
  }, [_vm._v("\n        Displaying " + _vm._s(_vm.displayedTranscripts.length) + " of " + _vm._s(_vm.transcripts.length) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.loadingTranscripts && _vm.displayedTranscripts.length === 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('empty', {
    staticStyle: {
      "font-size": "1.2em"
    }
  }, [_vm._v("No voice notes found")])], 1)]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-660f0e7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/voiceIntelligence/VoiceNotesGrid.vue
// module id = 3312
// module chunks = 3